import React from 'react';
import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  message,
  className = '',
}) => {
  const { t } = useTranslation();

  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  return (
    <div
      className={`flex flex-col items-center justify-center p-8 ${className}`}
    >
      <div
        className={`${sizeClasses[size]} border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin`}
        role="status"
        aria-label={message || t('common.loading')}
      />
      {message && (
        <p className="mt-4 text-sm text-text-secondary animate-pulse">
          {message}
        </p>
      )}
      {!message && (
        <p className="mt-4 text-sm text-text-secondary animate-pulse">
          {t('common.loading')}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;
